<div class="confirm-modal ig-modal source-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <div>
        <div class="title">Set ImGoing Version!</div>
        <p>{{ account.account.userName }}:</p>

        <ig-row>
            <ig-spinner *ngIf="loading"></ig-spinner>
            <ig-col [xs]="12" [md]="12" *ngIf="!loading">
                <p>Events</p>
                <div class="m-b-3">Set to V3 below will switch client site to V3!!</div>
                <!-- <div class="m-b-3">It doesn't mean this account will be switched to V3, please read the instructions
                    above</div> -->
                <mat-radio-group class="radio-group" [(ngModel)]="version.event.version"
                                 (ngModelChange)="setIgEventVersion()">
                    <mat-radio-button [value]="'V2'" class="m-r-3">
                        V2
                    </mat-radio-button>
                    <mat-radio-button [value]="'V3'">
                        V3 (new version!)
                    </mat-radio-button>
                </mat-radio-group>

            </ig-col>
        </ig-row>
        <ig-row>
            <ig-spinner *ngIf="loading"></ig-spinner>
            <ig-col [xs]="12" [md]="12" *ngIf="!loading">
                <p>Places</p>
                <div class="m-b-3">Set to V3 below will switch client site to V3!!</div>
                <!-- <div class="m-b-3">It doesn't mean this account will be switched to V3, please read the instructions
                    above</div> -->
                <mat-radio-group class="radio-group" [(ngModel)]="version.place.version"
                                 (ngModelChange)="setIgEventVersion()">
                    <mat-radio-button [value]="'V2'" class="m-r-3">
                        V2
                    </mat-radio-button>
                    <mat-radio-button [value]="'V3'">
                        V3 (new version!)
                    </mat-radio-button>
                </mat-radio-group>

            </ig-col>
        </ig-row>
        <ig-row>
            <ig-spinner *ngIf="loading"></ig-spinner>
            <ig-col [xs]="12" [md]="12" *ngIf="!loading">
                <p>Itinerary / Trip Planner</p>
                <div class="m-b-3">Set to V3 below will switch client site to V3!! But you can add version="V2" in the
                    embedding script to force to use V2
                </div>
                <mat-radio-group class="radio-group" [(ngModel)]="version.tripPlanner.version"
                                 (ngModelChange)="setIgEventVersion()">
                    <mat-radio-button [value]="'V2'" class="m-r-3">
                        V2
                    </mat-radio-button>
                    <mat-radio-button [value]="'V3'">
                        V3 (new version!)
                    </mat-radio-button>
                </mat-radio-group>

            </ig-col>
        </ig-row>

    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/set.ig.version/set.ig.version.modal.component.html